import React, { useState } from "react";
import styles from "./Login.module.css";

function Login({ onLoginSuccess }) {
  const [email, setEmail] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [erreur, setErreur] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErreur("");

    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          motDePasse, // le backend doit utiliser `req.body.motDePasse`
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        setErreur(data.message || "Erreur serveur.");
        return;
      }

      if (!data.token) {
        setErreur("Réponse invalide du serveur (pas de token).");
        return;
      }

      localStorage.setItem("token", data.token);
      onLoginSuccess();
    } catch (err) {
      console.error("Erreur login :", err);
      setErreur("Erreur réseau ou serveur.");
    }
  };

  return (
    <div className={styles.loginContainer}>
      <form onSubmit={handleSubmit} className={styles.loginCard}>
        <h2>Connexion</h2>

        <input
          type="email"
          placeholder="Adresse email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Mot de passe"
          value={motDePasse}
          onChange={(e) => setMotDePasse(e.target.value)}
          required
        />

        <button type="submit">Se connecter</button>

        {erreur && <p style={{ color: "red", marginTop: "1rem" }}>{erreur}</p>}
      </form>
    </div>
  );
}

export default Login;
